import React, { ComponentType, ReactNode } from 'react'

export type ExternalLinkProps = {
    value: string
    children: ReactNode
    className?: string
    openInNewTab?: boolean
    onClick?: () => void
}

export const ExternalLink: ComponentType<ExternalLinkProps> = ({
    children,
    value,
    openInNewTab = true,
    className,
    onClick
}) => (
    <a
        href={value}
        target={openInNewTab ? '_blank' : ''}
        rel="noreferrer"
        className={className}
        onClick={onClick}
    >
        {children}
    </a>
)
